import jsonToFormData from "@ajoelp/json-to-formdata";
import {errorNotify} from "./notify";

const getErrorDetails = (error) => {
    if (error && typeof error === 'object') {
        if (error.message) {
            return error.message;
        }

        if (error.statusText) {
            return error.statusText;
        }

        return error.toString();
    }

    if (typeof error === 'string') {
        return error;
    }

    return '';
};

const notifyApiError = (title, details = '') => {
    errorNotify(
        <div>
            <div style={{ fontWeight: 'bold', marginBottom: details ? 8 : 0 }}>
                {title}
            </div>
            {details && (
                <div style={{ fontSize: 13, color: '#666' }}>
                    {details}
                </div>
            )}
        </div>
    );
};

const handleApiResponse = (response, callback) => {
    if (!response.success) {
        const details = response.error || response.message || '';
        notifyApiError('Что-то пошло не так.', details);
    }

    callback(response, null);
};

const handleApiError = (error, callback) => {
    notifyApiError('Внутренняя ошибка сервера', getErrorDetails(error));
    callback(null, error);
};

export const apiGetWrapper = (apiUrl, callback) => {
    fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
        },
    })
        .then(response => response.json())
        .then(response => handleApiResponse(response, callback))
        .catch((error) => handleApiError(error, callback));
};

const apiRequestWrapper = (apiUrl, payload, callback) => {
    const options = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true,
        includeNullValues: false,
        mapping: function (value) {
            if (typeof value === 'boolean') {
                return +value ? 1 : 0;
            }
            return value;
        }
    };

    const form_data = jsonToFormData(
        payload,
        options
    );

    fetch(
        apiUrl,
        {
            method: 'POST',
            body: form_data,
            headers: {
                'X-CSRF-TOKEN': WAVE_LINE.csrf_token,
                'Accept': 'application/json'
            }
        }
    )
        .then(response => response.json())
        .then(response => handleApiResponse(response, callback))
        .catch((error) => handleApiError(error, callback));
};

export default apiRequestWrapper;
